import { render } from "./Page3.vue?vue&type=template&id=7ee67452&scoped=true"
import script from "./Page3.vue?vue&type=script&lang=js"
export * from "./Page3.vue?vue&type=script&lang=js"

import "./Page3.vue?vue&type=style&index=0&id=7ee67452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee67452"]])

export default __exports__